<template>
  <v-list subheader rounded>
    <v-list-item v-for="(file, index) in fileList" :key="index" class="border">
      <v-list-item-avatar>
        <v-icon class="grey lighten-1" dark>mdi-file</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title v-text="file.NOMBRE"></v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <v-row no-gutters>
          <v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="openFileMap(file)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Load on map</span>
            </v-tooltip>
          </v-col>
          <v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="downloadFile(file)">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Download</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ResultFileList',

  props: {
    fileList: Array
  },

  data: () => ({

  }),
  computed: {

  },
  methods: {
    ...mapActions('file', [
      'downloadFile'
    ]),
    openFileMap (file) {
      this.$router.push({ path: 'map', query: { idFile: file.ID_FICHERO } })
    }
  }
}
</script>

<style scoped>
  .border{
    border: 1px solid #CCC;
  }
</style>
